/** Router state carried into the form editor, naming the page it was opened from. */
export interface DesignerReturnState {
  designerReturnTo?: string;
}

export function designerReturnState(location: {
  pathname: string;
  search: string;
}): DesignerReturnState {
  return { designerReturnTo: `${location.pathname}${location.search}` };
}

/** Where the editor's Back goes, or undefined when it was opened on its own. */
export function designerReturnTo(state: unknown): string | undefined {
  const value = (state as DesignerReturnState | null | undefined)
    ?.designerReturnTo;

  return typeof value === "string" ? value : undefined;
}
